import React from 'react'
import { Link } from 'react-router-dom';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { Formik } from 'formik';
import { validationOpinion } from '../../../utils/validations';
import { makeStyles } from '@material-ui/core/styles';
import OpinionForm from '../../Forms/Opinion';
import SecondaryButton from '../../Buttons/SecondaryButton';
import ButtonBase from '../../Buttons/ButtonBase';

const useStyles = makeStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      display: 'flex',
      flexDirection: 'Column',
      width: 464,
      height: 392,
      borderRadius: 4,
      padding: '24px 28px 32px 28px',
      boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
      backgroundColor: 'white',
      '&:focus': {
        outline: 'none'
      }
    },
    close: {
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'pointer'
  
    },
    infoWrapper: {
      padding: '32px 38px 0',
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
    },
    name: {
      fontSize: 20,
      color: '#10587f',
      textAlign: 'center',
      marginBottom: 16,
      fontWeight: 'bold',
    },
    buttonsContainer: {
      display: 'flex',
      flexFlow: 'column',
      paddingTop: 40,
    },
    notNow: {
      background: 'unset',
      border: 0,
      fontSize: 14,
      fontWeight: 'bold',
      color: '#10587f',
      cursor: 'pointer',
      outline: 'unset'
    }
});

function ModalOpinion({ open, authClient, handleClose, clientLogged, formValues, handleSubmit }) {
    const classes = useStyles()
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div onClick={handleClose} className={classes.close}> <img src="/img/icons/close.svg" alt="close" /> </div>
            <div className={classes.infoWrapper}>
              <div>
                {clientLogged ?
                  ( <p id="spring-modal-title" className={classes.name}>Recomendar los servicios de <br />{authClient ? `${authClient.name} ${authClient.firstLastName} ${authClient.secondLastName}` : null}</p>)
                  :
                  (<p id="spring-modal-title" className={classes.name}>Para recomendar un abogado es necesario iniciar sesión</p>)
                }

     
              </div>

              {clientLogged ?
                <>
                  <Formik
                    initialValues={formValues}
                    validationSchema={validationOpinion}
                    onSubmit={handleSubmit}
                    render={props => < OpinionForm {...props} />}
                  />
                </>
                :
                <>
                  <div className={classes.buttonsContainer}>
                    <Link to='/usuario'>
                      <SecondaryButton variant="enable" style={{ width: 288, marginBottom: 32 }}>Inicia sesión</SecondaryButton>
                    </Link>
                    <Link to='/usuario-registro'>
                      <ButtonBase variant="primary" style={{ width: 288, marginBottom: 32 }}>Regístrate</ButtonBase>
                    </Link>

                    <button className={classes.notNow} onClick={handleClose}>Ahora no</button>
                  </div>

                </>
              }

            </div>
          </div>
        </Fade>
      </Modal>
    )
}

export default ModalOpinion
